import script from "./StaticsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StaticsPage.vue?vue&type=script&setup=true&lang=js"

import "./StaticsPage.vue?vue&type=style&index=0&id=1f85420a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f85420a"]])

export default __exports__